(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Minimal mobile menu toggle — click "Menu" / Esc / a nav link to open or
     close. Lives in a JS block so Shopify bundles it section-scoped. */
  (function () {
    function init() {
      var toggle = document.querySelector('[data-mobile-menu-toggle]');
      var menu = document.querySelector('[data-mobile-menu]');
      if (!toggle || !menu) return;

      function setOpen(open) {
        menu.setAttribute('aria-hidden', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('othr-mobile-menu-open', open);
      }

      toggle.addEventListener('click', function () {
        var isOpen = menu.getAttribute('aria-hidden') === 'false';
        setOpen(!isOpen);
      });

      // Close after the user taps a link inside the menu.
      menu.querySelectorAll('[data-mobile-menu-close]').forEach(function (a) {
        a.addEventListener('click', function () { setOpen(false); });
      });

      // Escape closes the menu.
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') setOpen(false);
      });

      // Clicking/tapping anywhere outside the drawer or the toggle closes it.
      document.addEventListener('click', function (e) {
        if (menu.getAttribute('aria-hidden') !== 'false') return;
        if (menu.contains(e.target) || toggle.contains(e.target)) return;
        setOpen(false);
      });

      // Crossing into lg+ closes the menu so it does not stay stuck open
      // behind a desktop layout that no longer shows the toggle.
      var lg = window.matchMedia('(min-width: 1024px)');
      lg.addEventListener('change', function (e) {
        if (e.matches) setOpen(false);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /* Mobile scroll-blur toggle */
  (function () {
    var header = document.querySelector('.othr-header');
    if (!header) return;
    var THRESHOLD = 10;
    function update() {
      if (window.innerWidth < 1024) {
        header.classList.toggle('is-scrolled', window.scrollY > THRESHOLD);
      } else {
        header.classList.remove('is-scrolled');
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-article"]) return;
  try {
    
  (function () {
    "use strict";
    var root = document.querySelector(".oba");
    if (!root) return;
    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    /* ---- TOC built from rendered <h2>s, with scrollspy ---- */
    var prose = $("[data-prose]");
    var tocBox = $("[data-toc]");
    var tocList = $("[data-toc-list]");
    var tocLinks = [];
    var headings = [];

    function slug(t, i) {
      var s = (t || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
      return "oba-" + (s || "section") + "-" + i;
    }
    if (prose && tocBox && tocList) {
      headings = $$("h2", prose);
      headings.forEach(function (h, i) {
        if (!h.id) h.id = slug(h.textContent, i);
        var n = String(i + 1);
        if (n.length < 2) n = "0" + n;
        // prepend a number chip inside the heading (brand motif)
        var num = document.createElement("span");
        num.className = "oba__h2num";
        num.textContent = n;
        h.insertBefore(num, h.firstChild);

        var li = document.createElement("li");
        var a = document.createElement("a");
        a.className = "oba__toc-link";
        a.href = "#" + h.id;
        a.innerHTML = '<span class="oba__toc-num">' + n + '</span> ' +
          (h.textContent || "").replace(n, "").trim();
        li.appendChild(a);
        tocList.appendChild(li);
        tocLinks.push(a);
      });
      if (headings.length) {
        tocBox.hidden = false;
        tocLinks.forEach(function (a) {
          a.addEventListener("click", function (e) {
            var target = document.getElementById(a.getAttribute("href").slice(1));
            if (!target) return;
            e.preventDefault();
            var y = target.getBoundingClientRect().top + window.scrollY - 88;
            window.scrollTo({ top: y, behavior: "smooth" });
            if (history.replaceState) history.replaceState(null, "", a.getAttribute("href"));
          });
        });
      }
    }

    function spy() {
      if (!headings.length) return;
      var mark = 140, active = 0;
      headings.forEach(function (h, i) {
        if (h.getBoundingClientRect().top - mark <= 0) active = i;
      });
      tocLinks.forEach(function (a, i) { a.classList.toggle("is-active", i === active); });
    }

    /* ---- reading-progress over the <article> ---- */
    var bar = $("[data-progress]");
    function progress() {
      if (!bar) return;
      var r = root.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      var pct = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      bar.style.width = (pct * 100).toFixed(1) + "%";
    }

    /* ---- back to top ---- */
    var toTop = $("[data-totop]");
    function toTopVis() {
      if (!toTop) return;
      toTop.hidden = false;
      toTop.classList.toggle("is-show", window.scrollY > window.innerHeight * 0.8);
    }
    if (toTop) toTop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: "smooth" }); });

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { progress(); toTopVis(); spy(); ticking = false; });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();

    /* ---- share ---- */
    var shareData = { title: document.title, text: document.title, url: location.href };
    if (navigator.share) $$('[data-share="native"]').forEach(function (b) { b.hidden = false; });

    function copyLink(btn) {
      var done = function () {
        if (!btn) return;
        var label = btn.textContent;
        btn.textContent = "Copied"; btn.classList.add("is-done");
        setTimeout(function () { btn.textContent = label; btn.classList.remove("is-done"); }, 1400);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareData.url).then(done, done);
      } else {
        var ta = document.createElement("textarea");
        ta.value = shareData.url; ta.style.position = "fixed"; ta.style.opacity = "0";
        document.body.appendChild(ta); ta.select();
        try { document.execCommand("copy"); } catch (e) {}
        document.body.removeChild(ta); done();
      }
    }
    $$("[data-share]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var kind = btn.getAttribute("data-share");
        var u = encodeURIComponent(shareData.url), t = encodeURIComponent(shareData.text);
        if (kind === "copy") return copyLink(btn);
        if (kind === "native" && navigator.share) { navigator.share(shareData).catch(function () {}); return; }
        var href = "";
        if (kind === "x") href = "https://twitter.com/intent/tweet?text=" + t + "&url=" + u;
        else if (kind === "wa") href = "https://wa.me/?text=" + t + "%20" + u;
        if (href) window.open(href, "_blank", "noopener,noreferrer");
      });
    });

    /* ---- save for later (localStorage) ---- */
    var saveBtn = $("[data-save]");
    if (saveBtn) {
      var key = "othr:saved:" + (root.getAttribute("data-article-key") || location.pathname);
      var txt = $(".oba__save-txt", saveBtn), icon = $(".oba__save-icon", saveBtn);
      var render = function (on) {
        saveBtn.classList.toggle("is-saved", on);
        saveBtn.setAttribute("aria-pressed", String(on));
        if (txt) txt.textContent = on ? "Saved" : "Save for later";
        if (icon) icon.innerHTML = on ? "&#9632;" : "&#9633;";
      };
      var on = false;
      try { on = localStorage.getItem(key) === "1"; } catch (e) {}
      render(on);
      saveBtn.addEventListener("click", function () {
        on = !on;
        try { on ? localStorage.setItem(key, "1") : localStorage.removeItem(key); } catch (e) {}
        render(on);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ══════════════════════════════════════════════
     1. VARIANT SELECT — price + image update
  ══════════════════════════════════════════════ */
  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('.othr-best-card__variant-select');
    if (!select) return;
    var card = select.closest('.othr-best-card');
    if (!card) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;

    /* Update ATC variant id */
    var atcBtn = card.querySelector('.othr-add-to-gear');
    if (atcBtn) atcBtn.dataset.variantId = opt.value;

    /* Update price display */
    var priceEl   = card.querySelector('[data-price-actual]');
    var compareEl = card.querySelector('[data-price-compare]');
    var badgeEl   = card.querySelector('[data-discount-badge]');

    var priceRaw   = parseInt(opt.dataset.priceRaw   || '0', 10);
    var compareRaw = parseInt(opt.dataset.compareRaw || '0', 10);

    if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;

    if (compareRaw > priceRaw && priceRaw > 0) {
      var pct = Math.round((compareRaw - priceRaw) / compareRaw * 100);
      if (badgeEl)   { badgeEl.textContent = pct + '% OFF'; badgeEl.hidden = false; }
      if (compareEl) { compareEl.textContent = opt.dataset.comparePrice || ''; compareEl.hidden = false; }
    } else {
      if (badgeEl)   badgeEl.hidden = true;
      if (compareEl) compareEl.hidden = true;
    }

    /* Swap image */
    var imgEl = card.querySelector('[data-variant-image]');
    if (!imgEl || !opt.dataset.image || imgEl.src === opt.dataset.image) return;
    imgEl.classList.add('is-swapping');
    setTimeout(function () {
      imgEl.src = opt.dataset.image;
      imgEl.onload = function () { imgEl.classList.remove('is-swapping'); imgEl.onload = null; };
      setTimeout(function () { imgEl.classList.remove('is-swapping'); }, 600);
    }, 250);
  });

  /* ══════════════════════════════════════════════
     2. ADD TO CART
  ══════════════════════════════════════════════ */
  // document.addEventListener('click', function (e) {
  //   var btn = e.target.closest && e.target.closest('.othr-add-to-gear');
  //   if (!btn) return;
  //   e.preventDefault();
  //   e.stopPropagation();

  //   var varId = btn.dataset.variantId || '';
  //   if (!varId) return;

  //   var labelEl = btn.querySelector('[data-cta-label]');
  //   var orig    = labelEl ? labelEl.textContent : 'Add to cart';
  //   if (labelEl) labelEl.textContent = 'Adding\u2026';
  //   btn.disabled = true;

  //   function restore() { if (labelEl) labelEl.textContent = orig; btn.disabled = false; }
  //   function ok()      { if (labelEl) labelEl.textContent = 'Added \u2713'; setTimeout(restore, 2000); }
  //   function fail()    { if (labelEl) labelEl.textContent = 'Error \u2014 retry'; setTimeout(restore, 2000); }

  //   if (window.OthrCart && typeof window.OthrCart.add === 'function') {
  //     window.OthrCart.add(varId, 1)
  //       .then(function () { ok(); if (window.OthrCart.open) window.OthrCart.open(); })
  //       .catch(fail);
  //     return;
  //   }

  //   fetch('/cart/add.js', {
  //     method : 'POST',
  //     headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
  //     body   : JSON.stringify({ id: parseInt(varId, 10), quantity: 1 })
  //   })
  //   .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
  //   .then(function () {
  //     ok();
  //     document.querySelectorAll('.othr-header__cart-count,[data-cart-count]').forEach(function (el) {
  //       el.textContent = (parseInt(el.textContent || '0', 10)) + 1;
  //     });
  //   })
  //   .catch(fail);
  // });

  /* ══════════════════════════════════════════════
     3. CAROUSEL — drag, arrows, dots
  ══════════════════════════════════════════════ */
  document.querySelectorAll('.othr-best-track').forEach(function (track) {
    var sid      = track.id.replace('othr-best-track-', '');
    var prevBtn  = document.getElementById('othr-best-prev-' + sid);
    var nextBtn  = document.getElementById('othr-best-next-' + sid);
    var dotsWrap = document.getElementById('othr-best-dots-' + sid);
    var slides   = track.querySelectorAll('.othr-best-slide');
    var dots     = dotsWrap ? dotsWrap.querySelectorAll('.othr-best-dot') : [];
    var total    = slides.length;
    if (!total) return;

    function visibleCount() {
      var w = track.offsetWidth;
      if (!w) return 3;
      var sw = slides[0].offsetWidth;
      return sw ? Math.round(w / sw) : 3;
    }
    function currentIndex() {
      var sw = slides[0] ? slides[0].offsetWidth : 1;
      return sw ? Math.round(track.scrollLeft / sw) : 0;
    }
    function goTo(index) {
      var max = total - visibleCount();
      index = Math.max(0, Math.min(index, max));
      var sw = slides[0] ? slides[0].offsetWidth : 0;
      track.scrollTo({ left: index * sw, behavior: 'smooth' });
    }
    function updateControls() {
      var idx = currentIndex();
      var max = total - visibleCount();
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= max;
      dots.forEach(function (dot, i) {
        var on = i === idx;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', String(on));
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - visibleCount()); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + visibleCount()); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.dotIndex, 10)); });
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateControls, 80);
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateControls, 200);
    });

    updateControls();
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-cart"]) return;
  try {
    
  (function () {
    var BYPASS = '_fd=0&_ab=0&_sc=1';
    function route(path) { return path + (path.indexOf('?') === -1 ? '?' : '&') + BYPASS; }
    function root() { return document.querySelector('[data-ocp]'); }
    function rootInner() { return document.querySelector('[data-ocp-root]'); }
    var MONEY_PREFIX = null;
    function moneyPrefix() {
      if (MONEY_PREFIX !== null) return MONEY_PREFIX;
      var el = document.querySelector('.ocp__total-val, .ocp__linetotal');
      var m = el ? el.textContent.trim().match(/^([^\d]*)/) : null;
      MONEY_PREFIX = (m && m[1]) || '₹';
      return MONEY_PREFIX;
    }
    function money(cents) {
      var r = Math.round((cents || 0) / 100), n;
      try { n = r.toLocaleString('en-IN'); } catch (e) { n = '' + r; }
      return moneyPrefix() + n;
    }
    var toastEl;
    function toast(msg) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'ocp-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translate(-50%,200%);opacity:0;z-index:9999;background:#111;color:#f8f8f7;padding:.8rem 1.25rem;font-size:.8rem;letter-spacing:.02em;transition:transform .35s ease,opacity .35s ease;max-width:90vw;pointer-events:none;font-family:inherit;';
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = msg;
      toastEl.style.transform = 'translate(-50%,0)';
      toastEl.style.opacity = '1';
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { toastEl.style.transform = 'translate(-50%,200%)'; toastEl.style.opacity = '0'; }, 2400);
    }
    var SECTION_ID = function () { var r = root(); return r ? r.getAttribute('data-section-id') : 'main'; };
    function swap(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ocp-root]');
      var current = rootInner();
      if (fresh && current) { current.innerHTML = fresh.innerHTML; animateDoBars(); var sd = storedDiscount(); if (sd) setDiscountMsg(sd); }
    }
    function applySections(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ocp-root]');
      var cur = rootInner();
      if (!fresh || !cur) return;
      var freshLines = Array.from(fresh.querySelectorAll('[data-line-key]'));
      if (freshLines.length === 0) { swap(html); return; }
      var freshByKey = Object.create(null);
      freshLines.forEach(function (l) { freshByKey[l.getAttribute('data-line-key')] = l; });
      var list = cur.querySelector('.ocp__list');
      Array.from(cur.querySelectorAll('[data-line-key]')).forEach(function (li) {
        var k = li.getAttribute('data-line-key');
        var f = freshByKey[k];
        if (!f) { li.remove(); return; }
        var fi = f.querySelector('[data-qty-input]'), ci = li.querySelector('[data-qty-input]');
        if (fi && ci && document.activeElement !== ci) ci.value = fi.value;
        var ft = f.querySelector('.ocp__linetotal'), ct = li.querySelector('.ocp__linetotal');
        if (ft && ct) ct.textContent = ft.textContent;
        var fu = f.getAttribute('data-unit-price'); if (fu) li.setAttribute('data-unit-price', fu);
        li.classList.remove('is-removing');
        delete freshByKey[k];
      });
      if (list) freshLines.forEach(function (f) {
        var k = f.getAttribute('data-line-key');
        if (k in freshByKey) list.appendChild(document.importNode(f, true));
      });
      var fSum = fresh.querySelector('.ocp__sum'), cSum = cur.querySelector('.ocp__sum');
      if (fSum && cSum) cSum.parentNode.replaceChild(document.importNode(fSum, true), cSum);
      copyText2('.ocp__sub', fresh, cur);
      animateDoBars();
      var sd = storedDiscount(); if (sd) setDiscountMsg(sd);
    }
    function copyText2(sel, fresh, cur) {
      var f = fresh.querySelector(sel), c = cur.querySelector(sel);
      if (f && c) c.textContent = f.textContent;
    }
    function lineUnit(li) { return parseInt(li.getAttribute('data-unit-price'), 10) || 0; }
    function recalcTotals() {
      var lis = Array.from(document.querySelectorAll('[data-line-key]:not(.is-removing)'));
      var subC = 0;
      lis.forEach(function (li) {
        var input = li.querySelector('[data-qty-input]');
        subC += lineUnit(li) * (input ? (parseInt(input.value, 10) || 0) : 0);
      });
      var sub = document.querySelector('.ocp__sum-rows .ocp__sum-row:first-child dd');
      if (sub) sub.textContent = money(subC);
      var tot = document.querySelector('.ocp__total-val'); if (tot) tot.textContent = money(subC);
    }
    function patchLine(li, qty) {
      var input = li.querySelector('[data-qty-input]'); if (input) input.value = qty;
      var lt = li.querySelector('.ocp__linetotal'); if (lt) lt.textContent = money(lineUnit(li) * qty);
    }
    var pending = Object.create(null), syncTimer = null, inflight = false;
    function queueChange(key, qty) {
      pending[key] = qty;
      if (syncTimer) clearTimeout(syncTimer);
      syncTimer = setTimeout(flush, 350);
    }
    function flush() {
      syncTimer = null; if (inflight) return;
      var keys = Object.keys(pending); if (!keys.length) return;
      var key = keys[0], qty = pending[key]; delete pending[key];
      inflight = true;
      postJSON('/cart/change.js', { id: key, quantity: Math.max(0, qty | 0), sections: SECTION_ID(), sections_url: window.location.pathname })
        .then(function (cart) { if (!Object.keys(pending).length && cart.sections && cart.sections[SECTION_ID()]) applySections(cart.sections[SECTION_ID()]); syncHeader(); })
        .catch(function () { window.location.reload(); })
        .then(function () { inflight = false; if (Object.keys(pending).length) flush(); });
    }
    function animateDoBars() {
      var panel = document.getElementById('discount-offers-panel'); if (!panel) return;
      panel.querySelectorAll('.do-fill[data-pct]').forEach(function (el) {
        var pct = Math.min(parseInt(el.getAttribute('data-pct'), 10) || 0, 100);
        el.style.transition = 'none'; el.style.width = '0%';
        requestAnimationFrame(function () { requestAnimationFrame(function () { el.style.transition = ''; el.style.width = pct + '%'; }); });
      });
    }
    function syncHeader() { if (window.OthrCart && typeof window.OthrCart.refresh === 'function') window.OthrCart.refresh(); }
    function postJSON(path, payload) {
      return fetch(route(path), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
    }
    function addVariant(id, qty) {
      return postJSON('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: qty || 1 }], sections: SECTION_ID(), sections_url: window.location.pathname })
        .then(function (data) { if (data.sections && data.sections[SECTION_ID()]) applySections(data.sections[SECTION_ID()]); syncHeader(); return data; });
    }
    function saveNote() {
      var n = document.querySelector('[data-note]'), giftOn = document.querySelector('[data-gift]'), giftMsg = document.querySelector('[data-gift-msg]');
      return postJSON('/cart/update.js', { note: n ? n.value : '', attributes: { gift: (giftOn && giftOn.checked) ? 'yes' : '', gift_message: giftMsg ? giftMsg.value : '' } }).catch(function () {});
    }
    var noteTimer;
    function debounceNote() { clearTimeout(noteTimer); noteTimer = setTimeout(saveNote, 500); }
    document.addEventListener('click', function (e) {
      if (!root()) return;
      var qtyBtn = e.target.closest('[data-qty]');
      if (qtyBtn && root().contains(qtyBtn)) {
        var li = qtyBtn.closest('[data-line-key]'), input = li.querySelector('[data-qty-input]');
        var cur = parseInt(input.value, 10) || 0, next = Math.max(0, qtyBtn.getAttribute('data-qty') === 'inc' ? cur + 1 : cur - 1);
        var key = li.getAttribute('data-line-key');
        if (next === 0) { li.classList.add('is-removing'); setTimeout(function () { li.remove(); recalcTotals(); toast('Removed from kit'); }, 300); }
        else { patchLine(li, next); recalcTotals(); }
        queueChange(key, next); return;
      }
      var rm = e.target.closest('[data-remove]');
      if (rm && root().contains(rm)) {
        e.preventDefault();
        var lineEl = rm.closest('[data-line-key]'), rkey = lineEl.getAttribute('data-line-key');
        lineEl.classList.add('is-removing');
        setTimeout(function () { lineEl.remove(); recalcTotals(); toast('Removed from kit'); }, 300);
        queueChange(rkey, 0); return;
      }
      var clear = e.target.closest('[data-clear]');
      if (clear && root().contains(clear)) {
        if (!window.confirm('Clear the whole kit?')) return;
        postJSON('/cart/clear.js', {}).then(function () { window.location.reload(); }); return;
      }
      var recAdd = e.target.closest('[data-rec-add]');
      if (recAdd && root().contains(recAdd) && !recAdd.disabled) {
        var vid = recAdd.getAttribute('data-rec-add'); recAdd.disabled = true;
        addVariant(vid, 1).then(function () { toast('Added to the kit'); }).catch(function () { toast('Could not add'); recAdd.disabled = false; }); return;
      }
      var promoApply = e.target.closest('[data-promo-apply]');
      if (promoApply && root().contains(promoApply)) { applyPromo(); return; }
    });
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (input && root() && root().contains(input)) {
        var li = input.closest('[data-line-key]');
        var v = parseInt((input.value || '').replace(/[^0-9]/g, ''), 10);
        if (isNaN(v) || v < 0) v = 1;
        if (v === 0) { li.classList.add('is-removing'); var k0 = li.getAttribute('data-line-key'); setTimeout(function () { li.remove(); recalcTotals(); }, 300); queueChange(k0, 0); }
        else { patchLine(li, v); recalcTotals(); queueChange(li.getAttribute('data-line-key'), v); }
      }
      var giftCb = e.target.closest('[data-gift]');
      if (giftCb && root() && root().contains(giftCb)) {
        var panel = document.querySelector('[data-gift-panel]'), flag = document.querySelector('[data-gift-flag]');
        if (panel) panel.hidden = !giftCb.checked;
        if (flag) flag.value = giftCb.checked ? 'yes' : '';
        if (giftCb.checked) { var gm = document.querySelector('[data-gift-msg]'); if (gm) gm.focus(); }
        saveNote();
      }
    });
    document.addEventListener('input', function (e) {
      if (!root()) return;
      if (e.target.closest('[data-note]') || e.target.closest('[data-gift-msg]')) debounceNote();
    });
    var STORE_DISCOUNT = 'othr_discount_code';
    function storedDiscount() { try { return (sessionStorage.getItem(STORE_DISCOUNT) || '').trim(); } catch (e) { return ''; } }
    function setDiscountMsg(code) {
      var msg = document.querySelector('[data-promo-msg]'), input = document.querySelector('[data-promo-input]');
      if (input && code && !input.value) input.value = code;
      if (msg && code) { msg.textContent = '✓ ' + code + ' will apply at checkout'; msg.className = 'ocp__promo-msg is-ok'; }
    }
    function applyPromo() {
      var input = document.querySelector('[data-promo-input]'), msg = document.querySelector('[data-promo-msg]');
      var code = (input.value || '').trim().toUpperCase();
      if (!code) { if (msg) { msg.textContent = 'Enter a code first.'; msg.className = 'ocp__promo-msg is-err'; } return; }
      input.value = code;
      try { sessionStorage.setItem(STORE_DISCOUNT, code); } catch (e) {}
      setDiscountMsg(code); toast(code + ' will apply at checkout');
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { var input = e.target.closest('[data-promo-input]'); if (input && root() && root().contains(input)) { e.preventDefault(); applyPromo(); } }
    });
    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
      return new Promise(function (resolve, reject) {
        try { var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px'; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); resolve(); } catch (e) { reject(e); }
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy-code]'); if (!btn || !root() || !root().contains(btn)) return;
      var code = btn.getAttribute('data-copy-code');
      try { sessionStorage.setItem(STORE_DISCOUNT, code); } catch (err) {}
      setDiscountMsg(code);
      copyText(code).then(function () {
        btn.classList.add('is-copied');
        var lab = btn.querySelector('[data-copy-label]'), orig = lab ? lab.textContent : '';
        if (lab) lab.textContent = 'Copied ✓';
        toast(code + ' copied · applies at checkout');
        clearTimeout(btn._t);
        btn._t = setTimeout(function () { btn.classList.remove('is-copied'); if (lab) lab.textContent = orig; }, 1800);
      }).catch(function () { toast('Press Ctrl+C to copy ' + code); });
    });
    function initOffers() { animateDoBars(); var sd = storedDiscount(); if (sd) setDiscountMsg(sd); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOffers);
    else initOffers();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    "use strict";
    const root = document.getElementById("othr-collist");
    if (!root) return;
    const $  = (s) => root.querySelector(s);
    const $$ = (s) => [...root.querySelectorAll(s)];

    const grid   = $("#oclGrid");
    const cards  = $$(".ocl-card");
    const tabsEl = $("#oclTabs");
    const none   = $("#oclNone");

    const counts = { all: cards.length, need: 0, format: 0, curated: 0, more: 0 };
    cards.forEach(c => { const g = c.dataset.group; if (counts[g] != null) counts[g]++; });
    $$("[data-count-for]").forEach(el => {
      const g = el.dataset.countFor;
      el.textContent = counts[g] || 0;
      const tab = el.closest(".ocl-tab");
      if (g !== "all" && !counts[g]) tab.hidden = true;
    });

    let group = "all";
    function apply() {
      let shown = 0;
      cards.forEach(c => {
        const vis = group === "all" || c.dataset.group === group;
        c.hidden = !vis;
        if (vis) shown++;
      });
      none.hidden = shown > 0;
      grid.hidden = shown === 0;
    }

    tabsEl.addEventListener("click", (e) => {
      const tab = e.target.closest(".ocl-tab");
      if (!tab || tab.hidden) return;
      group = tab.dataset.group;
      $$(".ocl-tab").forEach(t => {
        const on = t === tab;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      apply();
    });

    apply();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.oc');
    if (!root) return;
    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    /* IST clock + open/closed status (Mon–Sat, 9–18 IST) */
    var clockEl = $('#oc-clock');
    var statusEl = $('#oc-status');
    function istParts() {
      var now = new Date();
      var ist = new Date(now.getTime() + (now.getTimezoneOffset() + 330) * 60000);
      return { day: ist.getDay(), h: ist.getHours(), m: ist.getMinutes() };
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var p = istParts();
      if (clockEl) clockEl.textContent = pad(p.h) + ':' + pad(p.m) + ' IST';
      if (statusEl) {
        var open = p.day !== 0 && p.h >= 9 && p.h < 18;
        statusEl.innerHTML = open
          ? '<i class="oc-dot"></i> The line is open'
          : '<i class="oc-dot" style="animation:none;opacity:.4"></i> Off the floor — leave a note';
      }
    }
    tick();
    setInterval(tick, 30000);

    /* copy to clipboard */
    $$('.oc-ledger__copy').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var row = btn.closest('.oc-ledger__row');
        var text = row && row.getAttribute('data-copy');
        if (!text) return;
        var done = function () {
          var label = btn.textContent;
          btn.textContent = 'Copied';
          btn.classList.add('is-done');
          setTimeout(function () { btn.textContent = label; btn.classList.remove('is-done'); }, 1400);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (err) {}
          document.body.removeChild(ta); done();
        }
      });
    });

    /* char counter */
    var msg = $('#oc-message');
    var count = $('#oc-count');
    if (msg && count) {
      var max = parseInt(msg.getAttribute('maxlength'), 10) || 1000;
      var update = function () {
        var n = msg.value.length;
        count.textContent = n + ' / ' + max;
        count.classList.toggle('is-near', n > max * 0.9);
      };
      msg.addEventListener('input', update);
      update();
    }

    /* client-side validation (lets the real Shopify POST through when valid) */
    var form = $('#oc-form');
    if (!form) return;
    var fName = $('#oc-name'), fEmail = $('#oc-email'), fSubject = $('#oc-subject');
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    function wrap(i) { return i.closest('.oc-field'); }
    function mark(i, bad) { var w = wrap(i); if (w) w.classList.toggle('is-invalid', bad); return !bad; }
    function vName() { return mark(fName, fName.value.trim().length < 1); }
    function vEmail() { return mark(fEmail, !EMAIL_RE.test(fEmail.value.trim())); }
    function vSubject() { return mark(fSubject, fSubject.value.trim().length < 1); }
    function vMessage() { return mark(msg, msg.value.trim().length < 1); }

    [fName, fEmail, fSubject, msg].forEach(function (i) {
      if (!i) return;
      var re = function () {
        var w = wrap(i);
        if (!w || !w.classList.contains('is-invalid')) return;
        if (i === fName) vName(); else if (i === fEmail) vEmail();
        else if (i === fSubject) vSubject(); else if (i === msg) vMessage();
      };
      i.addEventListener('blur', re);
      i.addEventListener('input', re);
    });

    form.addEventListener('submit', function (e) {
      var ok = [vName(), vEmail(), vSubject(), vMessage()];
      if (ok.indexOf(false) !== -1) {
        e.preventDefault();
        var bad = [fName, fEmail, fSubject, msg].filter(function (i) { return wrap(i).classList.contains('is-invalid'); })[0];
        if (bad) bad.focus();
        return;
      }
      var send = $('#oc-send');
      if (send) { send.disabled = true; var lbl = send.querySelector('.oc-btn__label'); if (lbl) lbl.textContent = 'Sending…'; }
    });

    /* faq accordion: single-open */
    var items = $$('.oc-faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) items.forEach(function (o) { if (o !== item) o.open = false; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-footer"] && !Shopify.designMode) return;
  try {
    
  /* Force every footer accordion `<details>` open at ≥1024px so the
     desktop layout renders as a row of always-visible columns. Below
     that breakpoint, we leave the [open] attribute alone — the user
     toggles each column themselves via summary clicks.
     Re-runs on resize so a viewport-cross into lg+ also opens them. */
  (function () {
    function syncFooterAccordions() {
      var isLg = window.matchMedia('(min-width: 1024px)').matches;
      if (!isLg) return;
      document.querySelectorAll('#contact .othr-footer-col').forEach(function (el) {
        if (!el.hasAttribute('open')) el.setAttribute('open', '');
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncFooterAccordions);
    } else {
      syncFooterAccordions();
    }
    window.addEventListener('resize', syncFooterAccordions);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-hero"] && !Shopify.designMode) return;
  try {
    
  /* Hero product carousel. Reads block JSON from
     <script type="application/json" data-hero-blocks> and swaps content
     into the SSR'd slots on tab interaction. The Add to cart button
     keeps `othr-add-to-gear` so othr-cart.js handles the actual cart
     add + drawer open; we just rewrite its data-variant-id per slot. */
  (function () {
    var hero = document.querySelector('section.othr-hero[data-othr-dark]');
    if (!hero) return;

    // Header dark-mode toggle on scroll (matches the live behavior — the
    // <header> swaps its color scheme while the dark hero is in view).
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          document.body.classList.toggle('othr-dark-hero-visible', e.isIntersecting);
        });
      }, { rootMargin: '-72px 0px 0px 0px', threshold: 0 }).observe(hero);
    }

    var dataScript = hero.querySelector('[data-hero-blocks]');
    if (!dataScript) return;
    var blocks;
    try { blocks = JSON.parse(dataScript.textContent || '[]'); } catch (_) { blocks = []; }
    if (!blocks.length) return;

    var elImg     = hero.querySelector('#othr-hero-img');
    var elEyebrow = hero.querySelector('#othr-hero-eyebrow');
    var elPre     = hero.querySelector('#othr-hero-pre');
    var elEm      = hero.querySelector('#othr-hero-em');
    var elDesc    = hero.querySelector('#othr-hero-desc');
    var elKcal    = hero.querySelector('#othr-hero-kcal');
    var elProt    = hero.querySelector('#othr-hero-protein');
    var elFiber   = hero.querySelector('#othr-hero-fiber');
    var elSku     = hero.querySelector('#othr-hero-sku');
    var elPrice   = hero.querySelector('#othr-hero-price');
    var elSize    = hero.querySelector('#othr-hero-size');
    var elGhost   = hero.querySelector('#othr-hero-ghost');
    var elCopy    = hero.querySelector('#othr-hero-copy');
    var elRadial  = hero.querySelector('#othr-hero-radial');
    var elGlow    = hero.querySelector('#othr-hero-glow');
    var elBuy     = hero.querySelector('#othr-hero-buy');
    var tabsAll   = hero.querySelectorAll('.othr-tab, .othr-tab-m');

    function hexToRgbParts(hex) {
      if (!hex) return '123, 140, 255';
      var h = hex.replace('#', '');
      if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
      var n = parseInt(h, 16);
      return [(n >> 16) & 255, (n >> 8) & 255, n & 255].join(', ');
    }

    var currentIdx = -1;
    var swapTimer = null;

    function setActive(idx) {
      tabsAll.forEach(function (tab) {
        tab.classList.toggle('is-active', parseInt(tab.getAttribute('data-othr-tab'), 10) === idx);
      });
    }

    function applyBlock(idx) {
      if (idx === currentIdx) return;
      var b = blocks[idx];
      if (!b) return;
      currentIdx = idx;

      // Image swap with the live's blur-in animation.
      if (elImg && elImg.tagName === 'IMG' && b.img) {
        var preload = new Image();
        preload.src = b.img;
        elImg.style.animation = 'none';
        // Force reflow so the animation re-fires.
        void elImg.offsetWidth;
        elImg.src = b.img;
        elImg.alt = b.alt || '';
        elImg.style.animation = 'othrBarSwap 800ms cubic-bezier(.2,.7,.2,1) both';
      }

      // Copy fade.
      if (elCopy) {
        elCopy.style.animation = 'none';
        void elCopy.offsetWidth;
        elCopy.style.animation = 'othrFade 700ms ease both';
      }

      if (elEyebrow) {
        var n2 = (idx + 1) < 10 ? '0' + (idx + 1) : '' + (idx + 1);
        elEyebrow.textContent = n2 + ' / ' + (b.category || '');
        elEyebrow.style.color = b.accent;
      }
      if (elPre)   elPre.textContent   = b.pre || '';
      if (elEm)    elEm.textContent    = b.em || '';
      if (elDesc)  elDesc.textContent  = b.tagline || '';
      if (elKcal)  elKcal.textContent  = b.kcal || '—';
      if (elProt)  elProt.textContent  = b.protein || '—';
      if (elFiber) elFiber.textContent = b.fiber || '—';
      if (elSku) {
        var skuTxt = (b.sku || '').toString().trim();
        if (skuTxt) {
          elSku.textContent = skuTxt;
          elSku.hidden = false;
        } else {
          elSku.textContent = '';
          elSku.hidden = true;
        }
      }
      if (elSize)  elSize.textContent  = b.size || '';
      if (elPrice) elPrice.innerHTML   = b.price || '—';
      if (elGhost) elGhost.textContent = b.ghost || '';

      var rgb = hexToRgbParts(b.accent);
      hero.style.setProperty('--othr-accent', b.accent);
      hero.style.setProperty('--othr-accent-rgb', rgb);
      if (elRadial) elRadial.style.background = 'radial-gradient(55% 60% at 22% 55%, rgba(' + rgb + ', 0.35) 0%, transparent 70%)';
      if (elGlow)   elGlow.style.background   = 'rgba(' + rgb + ', 0.35)';
      if (elBuy) {
        elBuy.style.borderColor = b.accent;
        if (b.variantId) {
          elBuy.setAttribute('data-variant-id', b.variantId);
          elBuy.disabled = false;
        } else {
          elBuy.removeAttribute('data-variant-id');
          elBuy.disabled = true;
        }
      }

      setActive(idx);
    }

    // Initial paint already done server-side. Mark first tab active.
    setActive(0);
    currentIdx = 0;
    // Seed --othr-accent on the section so the side-rail uses the right hex.
    var initialAccent = hero.getAttribute('data-hero-initial-accent') || '#7B8CFF';
    hero.style.setProperty('--othr-accent', initialAccent);
    hero.style.setProperty('--othr-accent-rgb', hexToRgbParts(initialAccent));

    tabsAll.forEach(function (tab) {
      var idx = parseInt(tab.getAttribute('data-othr-tab'), 10);
      tab.addEventListener('mouseenter', function () {
        clearTimeout(swapTimer);
        swapTimer = setTimeout(function () { applyBlock(idx); }, 80);
      });
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(swapTimer);
        applyBlock(idx);
      });
      tab.addEventListener('focus', function () { applyBlock(idx); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-manifesto-beliefs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.othr-manifesto-beliefs');
    sections.forEach(function(sect) {
      var rows = sect.querySelectorAll('.othr-manifesto-beliefs__row');
      var imgs = sect.querySelectorAll('.othr-manifesto-beliefs__img');
      var badge = sect.querySelector('[data-belief-badge]');
      var caption = sect.querySelector('[data-belief-caption]');
      var total = rows.length;
      if (!total) return;

      // Cache captions/badge prefix from initial render
      var titles = Array.from(rows).map(function(li) {
        var h = li.querySelector('.othr-manifesto-beliefs__title');
        return h ? h.textContent.replace(/\.$/, '').trim() : '';
      });
      var badgePrefix = badge ? badge.textContent.trim() : 'belief';

      function setActive(idx) {
        rows.forEach(function(li, i) { li.classList.toggle('is-active', i === idx); });
        imgs.forEach(function(im) {
          var imgIdx = parseInt(im.getAttribute('data-belief-index'), 10);
          im.classList.toggle('is-active', imgIdx === idx);
        });
        if (badge) badge.textContent = badgePrefix;
        if (caption) caption.textContent = titles[idx] || '';
        sect.setAttribute('data-active-belief', idx);
      }

      rows.forEach(function(li) {
        var idx = parseInt(li.getAttribute('data-belief-index'), 10);
        li.addEventListener('mouseenter', function() { setActive(idx); });
        li.addEventListener('focus', function() { setActive(idx); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-manifesto-team"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.othr-manifesto-team').forEach(function (sect) {
      var cards = sect.querySelectorAll('.othr-manifesto-team__card');
      if (!cards.length) return;

      // Active-card affordance on hover
      cards.forEach(function (card) {
        card.addEventListener('mouseenter', function () {
          cards.forEach(function (c) { c.classList.remove('is-active'); });
          card.classList.add('is-active');
        });
      });

      // Scroll parallax — mirrors React's g() hook:
      // p = clamp(-1,1, (1 - (mid / (vh + h))) * 2 - 1); translateY = p*-12 - index*4
      var imgs = sect.querySelectorAll('[data-team-parallax]');
      if (!imgs.length) return;
      var ticking = false;

      function update() {
        ticking = false;
        var rect = sect.getBoundingClientRect();
        var vh = window.innerHeight;
        var raw = 1 - (rect.top + rect.height / 2) / (vh + rect.height);
        var p = Math.max(-1, Math.min(1, raw * 2 - 1));
        imgs.forEach(function (im) {
          var i = parseInt(im.getAttribute('data-team-parallax'), 10) || 0;
          var y = p * -12 - i * 4;
          im.style.setProperty('--team-parallax-y', y.toFixed(2) + 'px');
        });
      }
      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }
      // Compose parallax translate with the hover scale via CSS variable.
      imgs.forEach(function (im) { im.style.transform = 'translateY(var(--team-parallax-y, 0px))'; });
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-policies"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.opol');
    if (!root) return;
    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    /* measure the fixed header into --opol-header so sticky offsets line up */
    function syncHeader() {
      var hd = document.querySelector('.othr-header');
      if (hd && hd.offsetHeight) root.style.setProperty('--opol-header', hd.offsetHeight + 'px');
    }
    syncHeader();
    window.addEventListener('resize', syncHeader);

    /* per-doc read time (computed from rendered text) */
    $$('.opol-doc').forEach(function (doc) {
      var bodyEl = $('[data-opol-body]', doc);
      var slot = $('[data-opol-readtime]', doc);
      if (!bodyEl || !slot) return;
      var words = (bodyEl.textContent || '').trim().split(/\s+/).length;
      var mins = Math.max(1, Math.round(words / 200));
      slot.textContent = '~' + mins + ' min read';
    });

    /* reading progress + back-to-top */
    var bar = $('[data-opol-progress]');
    var totop = $('[data-opol-totop]');
    function onScroll() {
      var de = document.documentElement;
      var max = de.scrollHeight - de.clientHeight;
      var pct = max > 0 ? (de.scrollTop / max) * 100 : 0;
      if (bar) bar.style.width = pct.toFixed(2) + '%';
      if (totop) {
        var show = de.scrollTop > 600;
        totop.hidden = !show;
        totop.classList.toggle('is-show', show);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (totop) totop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

    /* scroll-spy: light the active policy in the TOC + sync the mobile select */
    var docs = $$('.opol-doc');
    var navLinks = $$('[data-opol-nav] .opol__nav-link');
    var select = $('[data-opol-select]');
    function setActive(id) {
      navLinks.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-doc') === id); });
      if (select && select.value !== id) select.value = id;
    }
    if ('IntersectionObserver' in window && docs.length) {
      var activeId = docs[0].id;
      var lastId = docs[docs.length - 1].id;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) activeId = e.target.id; });
        setActive(atBottom() ? lastId : activeId);
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
      docs.forEach(function (d) { io.observe(d); });
      // a short final doc can't scroll to the top, so pin it active near page-end
      function atBottom() {
        var de = document.documentElement;
        return (de.scrollTop + de.clientHeight) >= (de.scrollHeight - 4);
      }
      window.addEventListener('scroll', function () { if (atBottom()) setActive(lastId); }, { passive: true });
      setActive(activeId);
    }

    /* smooth-scroll for TOC links + mobile select, accounting for the fixed header */
    function scrollToId(id) {
      var t = document.getElementById(id);
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    navLinks.forEach(function (l) {
      l.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToId(l.getAttribute('data-doc'));
      });
    });
    if (select) select.addEventListener('change', function () { scrollToId(select.value); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-policy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.ospol');
    if (!root) return;
    var $ = function (s, c) { return (c || root).querySelector(s); };

    function syncHeader() {
      var hd = document.querySelector('.othr-header');
      if (hd && hd.offsetHeight) root.style.setProperty('--ospol-header', hd.offsetHeight + 'px');
    }
    syncHeader();
    window.addEventListener('resize', syncHeader);

    /* read time from rendered body text */
    var bodyEl = $('[data-ospol-body]');
    var slot = $('[data-ospol-readtime]');
    if (bodyEl && slot) {
      var words = (bodyEl.textContent || '').trim().split(/\s+/).length;
      var mins = Math.max(1, Math.round(words / 200));
      slot.textContent = '~' + mins + ' min read';
    }

    /* reading progress + back-to-top */
    var bar = $('[data-ospol-progress]');
    var totop = $('[data-ospol-totop]');
    function onScroll() {
      var de = document.documentElement;
      var max = de.scrollHeight - de.clientHeight;
      var pct = max > 0 ? (de.scrollTop / max) * 100 : 0;
      if (bar) bar.style.width = pct.toFixed(2) + '%';
      if (totop) {
        var show = de.scrollTop > 600;
        totop.hidden = !show;
        totop.classList.toggle('is-show', show);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (totop) totop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["othr-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-opd]').forEach(function (root) {
      var main      = root.querySelector('[data-opd-main]');
      var priceEl   = root.querySelector('[data-opd-price]');
      var compareEl = root.querySelector('[data-opd-compare]');
      var unitEl    = root.querySelector('[data-opd-unit]');
      var codeEl    = root.querySelector('[data-opd-code]');
      var qtyValEl  = root.querySelector('[data-opd-qty-val]');
      var addLabel  = root.querySelector('[data-opd-add-label]');
      var stickyPrice = root.querySelector('[data-opd-sticky-price]');
      var sizes     = root.querySelectorAll('[data-opd-sizes] .opd__size');
      var modes     = root.querySelectorAll('[data-opd-modes] .opd__mode');
      var addBtns   = root.querySelectorAll('[data-opd-add]');
      var thumbBtns = root.querySelectorAll('[data-opd-thumb]');
      var hiddenVar = root.querySelector('input[data-opd-variant]');

      var state = {
        variantId : '',
        priceFmt  : priceEl ? priceEl.textContent.trim() : '',
        available : !(addBtns[0] && addBtns[0].disabled),
        qty       : 1,
        plan      : ''
      };

      var activeSize = root.querySelector('[data-opd-sizes] .opd__size.is-active');
      if (activeSize) {
        state.variantId = activeSize.getAttribute('data-opd-variant');
        state.available = activeSize.getAttribute('data-available') !== '0';
        state.priceFmt  = activeSize.getAttribute('data-price-fmt');
      } else if (hiddenVar) {
        state.variantId = hiddenVar.getAttribute('data-opd-variant');
      }

      /* ── Helpers ── */
      function activeSizeTitle() {
        var a = root.querySelector('[data-opd-sizes] .opd__size.is-active');
        return a ? a.getAttribute('data-title') : '';
      }

      function renderAdd() {
        if (addLabel) {
          addLabel.textContent = !state.available
            ? 'Sold out'
            : 'Add ' + (state.qty > 1 ? state.qty + ' × ' : '') + state.priceFmt;
        }
        addBtns.forEach(function (b) { b.disabled = !state.available; });
        if (stickyPrice) {
          stickyPrice.textContent = state.priceFmt + (activeSizeTitle() ? ' · ' + activeSizeTitle() : '');
        }
      }

      /*
        swapMainImage — fades out the main stage image, swaps src, fades back in.
        Also activates the matching thumbnail if thumbIndex is provided.
      */
      function swapMainImage(newSrc, thumbIndex) {
        if (!main || !newSrc) return;
        if (main.src === newSrc) return; /* already showing this image */

        main.style.opacity = '0';
        setTimeout(function () {
          main.src = newSrc;
          main.onload = function () { main.style.opacity = '1'; main.onload = null; };
          /* fallback in case onload doesn’t fire (cached image) */
          setTimeout(function () { main.style.opacity = '1'; }, 400);
        }, 160);

        /* Sync thumbnail active state */
        if (thumbIndex !== undefined && thumbBtns.length) {
          thumbBtns.forEach(function (t) {
            var idx = parseInt(t.getAttribute('data-thumb-index'), 10);
            var isMatch = idx === thumbIndex;
            t.classList.toggle('is-active', isMatch);
            t.setAttribute('aria-selected', isMatch ? 'true' : 'false');
          });
        }
      }

      /* ── Thumbnail clicks (manual gallery navigation) ── */
      thumbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          thumbBtns.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          if (!main) return;
          var idx = parseInt(btn.getAttribute('data-thumb-index'), 10);
          swapMainImage(btn.getAttribute('data-src'), idx);
        });
      });

      /* ── Size / variant picker ── */
      sizes.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizes.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-checked', 'true');

          state.variantId = btn.getAttribute('data-opd-variant');
          state.available = btn.getAttribute('data-available') !== '0';
          state.priceFmt  = btn.getAttribute('data-price-fmt');

          if (priceEl)   priceEl.textContent = state.priceFmt;
          if (codeEl)    codeEl.textContent  = btn.getAttribute('data-sku') || btn.getAttribute('data-title');
          if (unitEl)    unitEl.textContent  = 'per ' + btn.getAttribute('data-title');

          if (compareEl) {
            var cmp    = btn.getAttribute('data-compare-fmt');
            var hasCmp = parseFloat(btn.getAttribute('data-compare')) > parseFloat(btn.getAttribute('data-price'));
            if (hasCmp && cmp) { compareEl.textContent = cmp; compareEl.hidden = false; }
            else { compareEl.hidden = true; }
          }

          /* ── Image swap on variant change ──
             data-image: full-size URL baked into each size button by Liquid.
             data-media-index: position in the media array for thumbnail sync. */
          var newImg    = btn.getAttribute('data-image');
          var mediaIdx  = parseInt(btn.getAttribute('data-media-index') || '0', 10);
          swapMainImage(newImg, mediaIdx);

          renderAdd();
        });
      });

      /* ── Purchase mode (subscribe / one-time) ── */
      modes.forEach(function (btn) {
        btn.addEventListener('click', function () {
          modes.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-checked', 'false'); });
          btn.classList.add('is-active');
          btn.setAttribute('aria-checked', 'true');
          state.plan = btn.getAttribute('data-opd-plan') || '';
        });
      });

      /* ── Quantity ── */
      root.querySelectorAll('[data-opd-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-opd-qty');
          if (dir === 'inc' && state.qty < 99) state.qty++;
          else if (dir === 'dec' && state.qty > 1) state.qty--;
          if (qtyValEl) qtyValEl.textContent = state.qty;
          renderAdd();
        });
      });

      /* ── Add to cart ── */
      addBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!state.available || !state.variantId) return;
          var opts = state.plan ? { selling_plan: state.plan } : undefined;
          var done = (window.OthrCart && window.OthrCart.add)
            ? window.OthrCart.add(state.variantId, state.qty, opts)
            : null;
          if (done && done.then) {
            done.then(function () {
              if (window.OthrCart && window.OthrCart.open) window.OthrCart.open();
            }).catch(function () {});
          }
        });
      });

      /* ── Buy Now ── */
      root.querySelectorAll('[data-opd-buynow]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!state.available || !state.variantId) return;
          if (window.SRCheckout && window.SRCheckout.initiateBuyNow) {
            window.SRCheckout.initiateBuyNow(state.variantId, state.qty);
          } else if (window.fastrr && window.fastrr.initiateBuyNow) {
            window.fastrr.initiateBuyNow(state.variantId, state.qty);
          }
        });
      });

      /* ── Sticky bar visibility ── */
      var sticky = root.querySelector('[data-opd-sticky]');
      var anchor = root.querySelector('.opd__buy');
      if (sticky && anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            sticky.classList.toggle('is-visible', !en.isIntersecting);
            sticky.setAttribute('aria-hidden', en.isIntersecting);
          });
        }, { rootMargin: '-90px 0px 0px 0px' }).observe(anchor);
      }

      renderAdd();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
